<template>
  <div>
    <!-- logo -->

    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>投标</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    
    <div class="top">

      <div>
        <img
        src="@/assets/community/back.png" 
          alt=""
          class="top-left-img"
          @click="back"
        />
      </div>
      <div>
        <img src="@/assets/work/toubiao.png" alt="" class="top-midlle-img" />
      </div>
      <div class="top-midlle-span">提交记录</div>
    </div>
    <!-- 中间 -->
    <div class="middle">
      <!-- 左半部分 -->
      <div class="middle-left">
        <!-- 选择器 -->
        <div class="selector">
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <div class="seach">
          <el-input v-model="input" placeholder="请输入招标名称"></el-input>
          <el-button type="primary">搜索</el-button>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="bottom">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="title" label="标题" width="250px">
        </el-table-column>
        <el-table-column prop="introduction" label="简介"> </el-table-column>
        <el-table-column prop="state" label="状态" width="120">
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="120">
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageProps.total"
        :page-size="pageProps.pageSize"
        :page-sizes="[5, 10, 50, 100]"
        :current-page="pageProps.pageNum"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageProps: {
        records: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
      },
      options: [
        {
          value: "选项1",
          label: "全部状态",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
      ],
      value: "选项1",
      input: "",
      tableData: [
        {
          title: "项目施工队",
          introduction: "这边需要20个木工和30个",
          state: "进行中",
          operation: "详情",
        },
        {
          title: "项目施工队",
          introduction: "这边需要20个木工和30个",
          state: "进行中",
          operation: "详情",
        },
        {
          title: "项目施工队",
          introduction: "这边需要20个木工和30个",
          state: "进行中",
          operation: "详情",
        },
        {
          title: "项目施工队",
          introduction: "这边需要20个木工和30个",
          state: "进行中",
          operation: "详情",
        },
        {
          title: "项目施工队",
          introduction: "这边需要20个木工和30个",
          state: "进行中",
          operation: "详情",
        },
        {
          title: "项目施工队",
          introduction: "这边需要20个木工和30个",
          state: "进行中",
          operation: "详情",
        },
      ],
    };
  },

  mounted() {
    this.fetchData();
  },
  methods: {
    // 当前页变更
    handleCurrentChange(num) {
      this.pageProps.pageNum = num;
      this.fetchData();
    },
    // 每页显示页面数变更
    handleSizeChange(size) {
      this.pageProps.pageSize = size;
      this.fetchData();
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  width: 950px;
  height: 31px;
  display: flex;
}

.top-left-img {
  margin-top: 8px;
  width: 25px;
  height: 25px;
}

.top-midlle-img {
  width: 40px;
  height: 40px;
}

.top-midlle-span {
  margin-left: 20px;
  margin-top: 8px;
  height: 16px;
  font-size: 16px;
  color: #181818;
  font-weight: bold;
}

.top-right {
  margin-top: 2px;
  margin-left: 740px;
}

.middle {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;

  .middle-left {
    display: flex;

    .selector {
      width: 100px;
      height: 28px;
      margin-left: 25px;
    }

    ::v-deep .el-input__inner {
      color: #181818;
    }

    .seach {
      // width: 192px;
      // height: 28px;
      display: flex;
      margin-left: 19px;

      .el-button--small {
        margin-left: 13px;
      }
    }
  }
}

.middle[data-v-cc741ad6] {
  width: 100%;
}
.bottom {
  margin-top: 26px;
  margin-left: 25px;
}
.paging {
  margin-top: 50px;
  display: flex;
  justify-content: flex-end;
}
</style>